import React from 'react';
import { theme } from '../../../style/global-style';
import { LabelledArrow } from '../labelled-arrow/labelled-arrow';
import {
    StyledArrowText,
    StyledExclusivesInnerWrapper,
    StyledExclusivesOuterWrapper,
    StyledLabelledArrowWrapper,
} from './highlightbar.style';

interface IHighlightbar {
    headline: string;
    color?: string;
    className?: string;
    children: React.ReactNode;
}

export const Highlightbar: React.FC<IHighlightbar> = ({
    headline,
    color = theme.colors.main4,
    className,
    children,
}) => {
    return (
        <StyledExclusivesOuterWrapper color={color}>
            <StyledLabelledArrowWrapper>
                <LabelledArrow left right backgroundColor={color} heightBox={22}>
                    <StyledArrowText>{headline}</StyledArrowText>
                </LabelledArrow>
            </StyledLabelledArrowWrapper>

            <StyledExclusivesInnerWrapper className={className}>
                {children}
            </StyledExclusivesInnerWrapper>
        </StyledExclusivesOuterWrapper>
    );
};
